import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { Wrapper } from "./Badge.styles";
var defaultProps = {
    type: "default",
    size: "default"
};
var Badge = function(param) {
    var text = param.text, icon = param.icon, type = param.type, size = param.size, className = param.className;
    if (!text) {
        return null;
    }
    var hasIcon = !!icon;
    return /*#__PURE__*/ _jsx(Wrapper, {
        badgeType: type,
        badgeSize: size,
        hasIcon: hasIcon,
        className: className,
        children: hasIcon ? /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("span", {
                    children: text
                }),
                icon
            ]
        }) : text
    });
};
Badge.defaultProps = defaultProps;
export { Badge };
